import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DatePipe, NgClass } from '@angular/common';
import { ORDER_GENERAL_FIELDS } from '@app/utils/constants/orders.constants';
import { OrderResponseDto } from '@app/utils/interfaces/order.interface';
@Component({
  selector: 'app-order-general-info',
  standalone: true,
  imports: [TranslatePipe, DatePipe, NgClass],
  templateUrl: './order-general-info.component.html',
  styleUrl: './order-general-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderGeneralInfoComponent {
  public readonly item = input<OrderResponseDto | null>(null);
  public readonly fields = ORDER_GENERAL_FIELDS;

  public formatOrderStatus(status: string): string {
    return status.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
}
